﻿"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BiMath = void 0;
class BiMath {
    static Init(web3) {
        this._web3 = web3;
    }
    static get Decimal() { return BigInt("1000000000000000000"); }
    static get Decimal20() { return BigInt("100000000000000000000"); }
    static get Zero() { return BigInt(0); }
    static ToBI(valueEth) { return BigInt(this._web3.utils.toWei(valueEth, "ether")); }
    static ToEth(valueBI) {
        const result = this._web3.utils.fromWei(valueBI + "", "ether");
        if (result == "0.")
            return "0";
        return result;
    }
}
exports.BiMath = BiMath;
//# sourceMappingURL=BiMath.js.map